// src/pages/admin/logs/components/LogHeader.js
import React from 'react';
import { Nav } from 'react-bootstrap';
import { Cpu, Terminal, Activity } from 'lucide-react';

const LogHeader = ({ activeTab, onSelectTab, showTabs }) => {
    return (
        <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
                <h2 className="activity-logs-title d-flex align-items-center gap-2">
                    <Cpu className="text-danger" size={28} /> System & Application Logs
                </h2>
                <p className="activity-logs-subtitle">Real-time audit monitoring for system errors and user workflow actions in bma_logs_db.</p>
            </div>
            
            {showTabs && (
                <Nav 
                    variant="pills" 
                    activeKey={activeTab} 
                    onSelect={onSelectTab} 
                    className="bg-dark p-1 rounded-3 border border-secondary"
                >
                    <Nav.Item>
                        <Nav.Link eventKey="system" className="d-flex align-items-center gap-2 text-white">
                            <Terminal size={16} /> 🖥️ System Logs
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="application" className="d-flex align-items-center gap-2 text-white">
                            <Activity size={16} /> 📱 Application Logs
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            )}
        </div>
    );
};

export default LogHeader;
